<template>
  <div class="text-center">
    <v-card class="outlined" flat>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        height="5"
        class="ma-0"
      ></v-progress-linear>

      <template v-else>
        <v-card dark flat color="primary" class="tile">
          <v-card-text>
            <h2 class="headline font-weight-regular">Select Organization</h2>
          </v-card-text>
        </v-card>

        <v-card-text>
          <v-list
            two-line
            style="max-height: 600px; max-width: 600px; overflow: auto"
          >
            <template v-for="(item, index) in organizations">
              <v-list-item
                @click="setOrganization(item)"
                :key="item.id || index"
              >
                <v-list-item-content
                  data-cy="moduleAuthComponentSelectOrganization"
                >
                  <v-list-item-title v-html="item.name"></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="item.email"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index + 1 < organizations.length"
                color="white"
              ></v-divider>
            </template>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-btn text class="ma-0" large block dark @click="login">
            Cancel
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import userService from "../../User/service.js";

export default {
  name: "AuthenticationSelectOrganization",
  props: ["Organizations"],
  data() {
    return {
      organizations: [],
      isLoading: true,
      noOrganization: false,
    };
  },
  async created() {
    if (this.Organizations) {
      this.organizations = this.Organizations;
      this.isLoading = false;
      console.log("Organizations (prop):", this.organizations);
    } else {
      try {
        const response = await userService.getCurrent({
          includeOrganizations: true,
        });
        console.log("Response (select org):", response);

        const orgs =
          response.data && response.data.Organizations
            ? response.data.Organizations
            : [];

        if (orgs.length === 0) {
          this.$router.push("/newOrganization");
        } else if (orgs.length === 1) {
          this.setOrganization(orgs[0]);
        } else {
          this.organizations = orgs;
        }
      } catch (error) {
        console.error("Error getting organizations", error);
        this.noOrganization = true;
      } finally {
        this.isLoading = false;
      }
    }
  },
  methods: {
    ...mapActions("global", ["initOrganization"]),
    login() {
      this.$router.push({ path: "/login" });
    },
    async setOrganization(val) {
      try {
        await this.initOrganization(val);
        this.$router.push({ path: "/" });
      } catch (error) {
        console.error("Error setting organization", error);
      }
    },
  },
};
</script>